import setCurrentPage from "src/Utils/setCurrentPage";
import store from "src/Reducers/store";

const previousPage = () => store.getState().appReducer.previousPage;

export const DATA_AI_TWIN_DEMO_1 = {
  title:
    "Meet Maya, the CMO of a Telecom\n company.  She constantly seeks real-\ntime visibility & measurement of \ncampaign effectiveness, actionable \ninsights into customer behavior, buying \ntrends, and marketing ROI.",
  subtitle: "DEFINE/REFINE MARKETING STRATEGY IN REALTIME",
  text: "See how AI Twin for Marketer transforms her approach, \nempowering & enabling Maya to activate informed marketing \ndecisions to stay ahead in the industry.",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(306),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(previousPage()),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "AI_TWIN/AI_Twin_04.png",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  rightSideImage: "AI_TWIN/AI_TWIN_DEMO_1_character.png",
  imageCustomStyle: {
    position: "absolute",
    bottom: 0,
    right: 0,
  },
};
